import { render, staticRenderFns } from "./QuizCommentView.vue?vue&type=template&id=5fcbe8d4&"
import script from "./QuizCommentView.vue?vue&type=script&lang=js&"
export * from "./QuizCommentView.vue?vue&type=script&lang=js&"
import style0 from "./QuizCommentView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports